import { render, staticRenderFns } from "./detail6.vue?vue&type=template&id=3f013abc&scoped=true"
import script from "./detail6.vue?vue&type=script&lang=js"
export * from "./detail6.vue?vue&type=script&lang=js"
import style0 from "./detail6.vue?vue&type=style&index=0&id=3f013abc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f013abc",
  null
  
)

export default component.exports